import React, { useState } from "react";
import bg from "../assets/Resources (1).webp";
import aboutus from "../assets/aboutus.webp";
import ourmission from "../assets/j.webp";
import ourvision from "../assets/ourmission.webp";
import Resources from "../assets/Resources.webp";
import WaitlistForm from "./emailForm";
import tm from "../assets/tm.png";
const Aboutus = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <div className="relative w-full bg-black overflow-hidden p-2">
      <img
        src={bg}
        className="absolute left-0 top-24 z-0 w-[380px] lg:w-[260px] md:w-[200px] sm:hidden opacity-70"
      />
      <div className="relative z-10 max-w-full px-6 pt-32 space-y-32">
        <div className="flex items-center gap-16 lg:gap-10 md:flex-col">
          {/* TEXT */}
          <div className="flex-1 max-w-[600px] xl:max-w-[520px]">
            <h2 className="font-[Norwester] text-[#FFF528] text-[60px] xl:text-[46px] md:text-3xl mb-4">
              ABOUT US
            </h2>

            <p className="text-white/80 text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[13px] leading-relaxed">
              At vupop, we are driven by a single goal: to bridge the gap
              between sports fans and broadcasters. Founded by a team of
              passionate sports enthusiasts and media experts, vupop leverages
              cutting-edge technology to amplify the voices of fans and enhance
              the reach of broadcasters.
            </p>
          </div>

          {/* IMAGE */}
          <div className="flex-1 flex justify-end md:w-full">
            <img
              src={aboutus}
              className="w-[700px] h-[300px] xl:w-[550px] xl:h-[200px] object-cover rounded-2xl md:w-full md:h-[180px]"
            />
          </div>
        </div>

        <div className="flex items-center gap-16 lg:gap-10 md:flex-col md:pl-0 pl-16">
          {/* TEXT */}
          <div className="flex-1 max-w-[600px] xl:max-w-[520px]">
            <h2 className="font-[Norwester] text-[#FFF528] text-[60px] xl:text-[46px] md:text-3xl mb-4">
              OUR MISSION
            </h2>

            <p className="text-white/80 text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[13px] leading-relaxed">
              To revolutionize sports media by enabling fans to share their
              experiences and broadcasters to tell deeper, more engaging
              stories. We provide the tools to make every match more interactive
              and every fan's cheer heard around the world.
            </p>
          </div>

          {/* IMAGE */}
          <div className="flex-1 flex justify-end md:w-full">
            <img
              src={ourmission}
              className="w-[630px] h-[300px] xl:w-[490px] xl:h-[220px] object-cover rounded-2xl md:w-full md:h-[200px]"
            />
          </div>
        </div>

        <div className="flex items-center gap-16 lg:gap-10 md:flex-col md:pl-0 pl-32">
          {/* TEXT */}
          <div className="flex-1 max-w-[600px] xl:max-w-[520px]">
            <h2 className="font-[Norwester] text-[#FFF528] text-[60px] xl:text-[46px] md:text-3xl mb-4">
              OUR VISION
            </h2>

            <p className="text-white/80 text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[13px] leading-relaxed">
              Imagine a world where every great sports moment can be shared and
              celebrated by a global community. At vupop, we are making that
              world a reality, one game at a time, ensuring that fan content not
              only supports but leads the narrative in sports broadcasting —
              while rewarding fans with money in their pocket.
            </p>
          </div>

          {/* IMAGE */}
          <div className="flex-1 flex justify-end md:w-full">
            <img
              src={ourvision}
              className="w-[560px] h-[300px] xl:w-[300px] xl:h-[240px] object-cover rounded-2xl md:w-full md:h-[200px]"
            />
          </div>
        </div>

        <div className="text-center pt-16 md:pt-24 pb-10 space-y-5 md:space-y-6 px-4">
          <div className="flex justify-center items-start gap-2 sm:gap-1">
            <img src={Resources} alt="logo" className="md:h-auto" />
            <img src={tm} alt="tm" className="h-10 w-10 sm:h-8 sm:w-8" />
          </div>
          <p className="text-white/80 max-w-[680px] xl:max-w-[520px] lg:max-w-[440px] md:max-w-full mx-auto text-[18px] xl:text-[16px] lg:text-[15px] md:text-[15px] sm:text-[14px] leading-relaxed">
            Join our exclusive waitlist today and be among the first to
            experience the future of fan-driven sports media
          </p>
          <div className="flex justify-center">
            <div className="flex sm:flex-col w-full max-w-[820px] xl:max-w-[600px] lg:max-w-[480px] md:max-w-full gap-3">
              <input
                className="w-full h-12 lg:h-10 sm:h-10 bg-black border border-[#FFF528] rounded-md px-3 text-white text-[16px] xl:text-[14px] lg:text-[13px] sm:text-[13px] placeholder:text-white/40"
                placeholder="abc@gmail.com"
              />
              <button
                onClick={() => setShowForm(true)}
                className="h-12 lg:h-10 sm:h-10 bg-[#FFF528] hover:bg-[#FFF528]/70 transition-colors text-black px-6 rounded-md font-semibold text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[13px] whitespace-nowrap"
              >
                Join Waitlist
              </button>
            </div>
          </div>
        </div>
      </div>
      {showForm == true && (
        <>
          <WaitlistForm />
        </>
      )}
    </div>
  );
};

export default Aboutus;
